import AccidentForm from "@/components/accident/accident-form";
import { useRefetchOnFocus } from "@/hooks/useRefetchOnFocus";
import { trpc } from "@/trpc/react";
import { useLocalSearchParams } from "expo-router";
import Drawer from "expo-router/drawer";
import { ActivityIndicator, View } from "react-native";
import { KeyboardAwareScrollView, KeyboardToolbar } from "react-native-keyboard-controller";


export default function ReportPage() {
  const { id } = useLocalSearchParams();

  const jobDateId = Number(id);

  const { data: jobData, isLoading, refetch } = trpc.jobDateListRouter.getById.useQuery(jobDateId);
  const { data: crewList, isLoading: crewListLoading } = trpc.crew.getCrewListForJobDate.useQuery(jobDateId);

  useRefetchOnFocus(refetch);


  if (isLoading || crewListLoading) {
    return (
      <View className="flex-1 justify-center">
        <ActivityIndicator />
      </View>
    );
  }

  return (
    <>
      <Drawer.Screen
        options={{
          title: "Accident",
        }}
      />
      <KeyboardAwareScrollView
        bottomOffset={62}
        className="flex-1 p-4">
        <AccidentForm jobDate={jobData?.data} crewList={crewList} />
      </KeyboardAwareScrollView>
      <KeyboardToolbar />
    </>
  )
}